module.exports = __webpack_public_path__ + "share_w.64d27d96.png";